import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from 'react-router-dom'

import { AuthenticatedLayout } from '@/layouts/AuthenticatedLayout/AuthenticatedLayout'
import { CommonLayout } from '@/layouts/CommonLayout/CommonLayout'
import { DefaultLayout } from '@/layouts/DefaultLayout/DefaultLayout'
import { FullWidthLayout } from '@/layouts/FullWidthLayout/FullWidthLayout'
import { PageLayout } from '@/layouts/PageLayout/PageLayout'

import {
  ADMIN_PRIVATE_ROUTES,
  ADVISORS_PRIVATE_ROUTES,
  AUTHENTICATED_LAYOUT_PRIVATE_ROUTES,
  DEFAULT_LAYOUT_PUBLIC_ROUTES,
  EMPLOYER_PRIVATE_ROUTES,
  FULLWIDTH_LAYOUT_PRIVATE_ROUTES,
  PAGES_LAYOUT_PUBLIC_ROUTES,
  USERS_PRIVATE_ROUTES,
} from '@/router/Router.constants'

import { RoleChecker } from '@/components/RoleChecker/RoleChecker'

import { role } from '@/__generated__/requests'

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<CommonLayout />}>
      <Route element={<AuthenticatedLayout />}>
        <Route element={<RoleChecker roles={[role.ADMIN]} />}>
          {ADMIN_PRIVATE_ROUTES.map(route => (
            <Route key={route.path} element={route.element} path={route.path} />
          ))}
        </Route>
        <Route element={<RoleChecker roles={[role.ADVISOR]} />}>
          {ADVISORS_PRIVATE_ROUTES.map(route => (
            <Route key={route.path} element={route.element} path={route.path} />
          ))}
        </Route>
        <Route element={<RoleChecker roles={[role.EMPLOYER]} />}>
          {EMPLOYER_PRIVATE_ROUTES.map(route => (
            <Route key={route.path} element={route.element} path={route.path} />
          ))}
        </Route>
        <Route
          element={
            <RoleChecker
              roles={[role.EMPLOYEE, role.ADVISOR, role.ADMIN, role.EMPLOYER]}
            />
          }
        >
          {USERS_PRIVATE_ROUTES.map(route => (
            <Route key={route.path} element={route.element} path={route.path} />
          ))}
        </Route>
        <Route element={<RoleChecker roles={[role.EMPLOYEE]} />}>
          {AUTHENTICATED_LAYOUT_PRIVATE_ROUTES.map(route => (
            <Route key={route.path} element={route.element} path={route.path} />
          ))}
        </Route>
      </Route>
      <Route element={<FullWidthLayout />}>
        <Route element={<RoleChecker roles={[role.EMPLOYEE]} />}>
          {FULLWIDTH_LAYOUT_PRIVATE_ROUTES.map(route => (
            <Route key={route.path} element={route.element} path={route.path} />
          ))}
        </Route>
      </Route>
      <Route element={<DefaultLayout />}>
        <Route element={<RoleChecker roles={[]} />}>
          {DEFAULT_LAYOUT_PUBLIC_ROUTES.map(route => (
            <Route key={route.path} element={route.element} path={route.path} />
          ))}
        </Route>
      </Route>
      <Route element={<PageLayout />}>
        <Route element={<RoleChecker roles={[]} />}>
          {PAGES_LAYOUT_PUBLIC_ROUTES.map(route => (
            <Route key={route.path} element={route.element} path={route.path} />
          ))}
        </Route>
      </Route>
    </Route>,
  ),
)

if (import.meta.hot) {
  import.meta.hot.dispose(() => router.dispose())
}

export function Router() {
  return <RouterProvider router={router} />
}
